import {useCallback, useEffect, useState} from 'react';
import http from '../http';
import {useNavigate, useParams} from 'react-router-dom';


export default function Update(props){
    const navigate=useNavigate();
    const {id}=useParams();

    const [inputs,setInputs] = useState({});
    // const fetchUser= () =>{
    //     http.get('/users/'+id+'/edit').then((res)=>{
    //         console.log('API Response:', res.data);
    //         setInputs({
    //             name:res.data.name,
    //             email:res.data.email,
    //             phone:res.data.phone,
                
    //         });
    //     });
    // }

    const fetchUser = useCallback(async () => {
        http.get('/users/'+id+'/edit').then((res)=>{
            console.log('API Response:', res.data);
            setInputs({
                name:res.data.name,
                email:res.data.email,
                phone:res.data.phone,
                
            });
        });
      }, [id]);
      
      useEffect(() => {
        fetchUser();
      }, [fetchUser]); //

    // useEffect(()=>{
    //     fetchUser();
    // },[fetchUser]);
       

    const handlechange = (event) =>{
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values,[name]:value}))
    }

    console.log(inputs)
    const submitForm = () =>{
        http.put('/users/'+id,inputs).then((res)=>{
            navigate('/');
             
        })
    }

    return (
        <div>
            <h1>Update User Data</h1>
            <div className='row'>
            <div className='col-sm-6 justify-content-center'>
                <div className='card p-4'>
                <label>Name</label>
                <input type='text' name='name' className='form-control mb-2' 
                value={inputs.name || ''}
                onChange={handlechange} />
                <label>Email</label>
                <input type='email' name='email' className='form-control mb-2'
                value={inputs.email || ''}
                onChange={handlechange} />
                <label>Phone</label>
                <input type='tel' name='phone' className='form-control mb-2' 
                value={inputs.phone || ''}
                onChange={handlechange}/>
               
                <button type="button" onClick={submitForm} className='btn btn-info mt-2'>Update</button>
            </div>
            </div>
            </div>
        </div>
    )
}